<template>
  <GetStartedInstructions
    :localStorageKey="localStorageKey"
    primaryLink="https://support.jumpcloud.com/support/s/article/getting-started-systems1-2019-08-21-10-36-47#About%20the%20Agent"
    primaryLinkText="learn more"
    :startCollapsed="collapsed"
    :title="`Get Started with ${deviceItem.titlePlural}`"
  >
    <GetStartedStep
      :icon="icons.IconStep1"
      :step="1"
      :text="`Choose a ${deviceItem.label} (Linux, Windows, Mac, Puppet, or Chef)`"
    />
    <GetStartedStep
      :icon="icons.IconStep2"
      :step="2"
      :text="`Install the agent (varies based on ${deviceItem.label} type).
      You have two options: manual install or command line.`"
    />
    <GetStartedStep
      :icon="icons.IconStep3"
      :step="3"
      :text="`Bind Users by clicking on the Users tab and select
      the checkbox of the User you want to bind to that ${deviceItem.label}.`"
    />
  </GetStartedInstructions>
</template>

<script>
import { LocalStorageConsts } from 'client/util/Constants';
import { mapGetters } from 'vuex';
import GetStartedInstructions from 'client/components/GetStartedInstructions/GetStartedInstructions.vue';
import GetStartedStep from 'client/components/GetStartedInstructions/GetStartedStep.vue';
import IconStep1 from 'public/img/icons/icon-step-1-choose-system.svg?inline';
import IconStep2 from 'public/img/icons/icon-step-2-install-system.svg?inline';
import IconStep3 from 'public/img/icons/icon-step-3-bind-users.svg?inline';
import ItemType from 'client/util/Constants/ItemType';

const { systemInstructionsDismissed } = LocalStorageConsts;
const { DeviceItemType } = ItemType;

export default {
  name: 'SystemInstructions',

  components: {
    GetStartedInstructions,
    GetStartedStep,
  },

  data: () => ({
    collapsed: false,
    deviceItem: new DeviceItemType(),
    localStorageKey: systemInstructionsDismissed,
    icons: {
      IconStep1,
      IconStep2,
      IconStep3,
    },
  }),

  computed: {
    ...mapGetters('SystemCollection', {
      totalCountOfAllItems: 'getTotalCountOfAllItems',
    }),
  },

  created() {
    this.checkSystemsCount();
  },

  methods: {
    checkSystemsCount() {
      // Collapse the instructions section if the admin has > 5 systems
      if (this.totalCountOfAllItems >= 5) this.collapsed = true;
    },
  },
};
</script>
